// Module
var code = "<cover> <div class=panel> <div class=panel-heading> <translate>Congratulations!</translate> <br/> <translate>You're all set!</translate> </div> <div class=\"panel-body text-center\"> <a ng-click=$ctrl.next() class=\"btn btn-block btn-primary\" translate>Click here to Continue</a> </div> </div> </cover> ";
// Exports
module.exports = code;